import React from 'react';
import { Text, useIsMobile } from '@amzn/storm-ui';
import { PopoverMultipleLines, PopoverWithContent } from './types';
import { KeyText } from './Attributes/styles';

export const MultipleLines = ({ lines }) =>
  lines?.map((line) => <Text key={line}>{line}</Text>);

export const DynamicPopover = ({
  popover,
}: {
  popover: PopoverWithContent | PopoverMultipleLines | string;
}) => {
  if (typeof popover === 'string') return <Text>{popover}</Text>;
  if ('lines' in popover) return <MultipleLines lines={popover.lines} />;
  if ('headerText' in popover)
    return (
      <>
        <Text>{popover.headerText}</Text>
        <Text>{popover.text}</Text>
        <MultipleLines lines={popover.list} />
      </>
    );
  return <Text>{JSON.stringify(popover)}</Text>;
};

export const isValidPopoverResponse = (popover) =>
  popover?.lines || popover?.headerText || popover?.list || popover?.text;

export const fontSize = () => (useIsMobile() ? 'base' : 'small');

export const KeyLabel = ({ label }) => {
  const keyFontSize = fontSize();
  if (!label) return null;
  return (
    <KeyText size={keyFontSize} color="secondary" inline={true} renderAs="span">
      {label}:
    </KeyText>
  );
};
